<template>
  <RCard class="price-usage-table">
    <UsageTitleModal ref="usageTitleModal" @new-title="updateTitle" />

    <Grid gaf="column" justify-content="space-between" align-items="center">
      <div class="text-subtitle-1 text-secondary-1">Price and Usage <HelpPageBtn :page="__guide.usageStats" /></div>

      <Grid gaf="column" align-items="center" gap="var(--r-space-md)">
        <RBtn size="small" type="text" @click="openDialog">Update usage column title</RBtn>
        <ShowHideCols ref="showHideCols" :ag-grid="agGrid" />
      </Grid>
    </Grid>

    <AgGrid
      v-if="subscription"
      ref="agGrid"
      :options="gridOptions"
      :row-data="clonedSubscriptionPeriods"
      @ready="agGrid = $event"
      @cell-value-changed="cellValueChanged"
    />
  </RCard>
</template>

<script>
import * as apiTo from '@/modular-api'
import { gridOptions } from './gridOptions'
// Libraries
import { mapState, mapMutations, mapActions } from 'vuex'
import { cloneDeep } from 'lodash'
// Components
import HelpPageBtn from '@/reusable/base-components/HelpPageBtn'
import AgGrid from '@/ag-grid/AgGrid'
import ShowHideCols from '@/ag-grid/components/show-hide-cols/ShowHideCols'
import UsageTitleModal from './UsageTitleModal'

export default {
  components: {
    AgGrid,
    HelpPageBtn,
    ShowHideCols,
    UsageTitleModal
  },

  mixins: [gridOptions],

  data: () => ({
    agGrid: null
  }),

  computed: {
    ...mapState('subscription-show', ['subscription', 'subscriptionPeriods']),

    clonedSubscriptionPeriods() {
      return cloneDeep(this.subscriptionPeriods)
    }
  },

  methods: {
    ...mapMutations('subscription-show', ['updatePeriod']),
    ...mapActions('subscription-show', ['updateSubscription']),

    openDialog() {
      this.$refs.usageTitleModal.show(this.subscription.usage_column.value.substr(6))
    },

    async updateTitle(newTitle) {
      await this.updateSubscription({
        id: this.subscription.id,
        key: 'usage_column',
        payload: {
          usage_column: `Usage ${newTitle}`
        }
      })
      this.updateAgGridUsageColumnName()
    },

    updateAgGridUsageColumnName() {
      this.agGrid.api.getColumnDef('usage').headerName = this.subscription.usage_column.value
      this.agGrid.api.refreshHeader()
      this.$refs.showHideCols.setAllColumns()
    },

    getPayload(row) {
      const clonedRow = cloneDeep(row)

      return {
        start_date: clonedRow.start_date,
        end_date: clonedRow.end_date,
        name_reference: clonedRow.name_reference,
        usage: clonedRow.usage,
        price: clonedRow.price,
        normalized_price: clonedRow.normalized_price
      }
    },

    didValueChanged(old, newVal) {
      if (typeof old === 'string' && typeof newVal === 'number') return Number(old) !== Number(newVal)
      return old !== newVal
    },

    cellValueChanged(event) {
      if (!this.didValueChanged(event.oldValue, event.newValue)) return

      const payload = this.getPayload(event.data)

      apiTo
        .MODIFY_SUBSCRIPTION_PERIOD(event.data.id, payload)
        .then(({ data }) => {
          this.updatePeriod(data.result)
          this.$emit('table-updated')
        })
        .catch(() => {
          const oldData = cloneDeep(this.subscriptionPeriods.find(p => p.id === event.data.id))
          this.$refs.agGrid.updateRow(event.data.id, oldData)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins';

.price-usage-table {
  @include table-with-no-filters;
}
</style>
